module.exports = __webpack_public_path__ + "static/img/higashi_02.e63a661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/higashi_02.png
// module id = uWjZ
// module chunks = 0